import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { DatePickerPresets } from '@global/GlobalFunctions';

@Component({
	selector: 'app-date-range-picker',
	templateUrl: './date-range-picker.component.html',
	styleUrl: './date-range-picker.component.scss'
})
export class DateRangePickerComponent {

	/** today - #71 */
	public today: Date = new Date()

	/** datePickerPresets - #71 */
	public datePickerPresets = DatePickerPresets;

	/** Date Picker Change */
	@Output() datePickerChange = new EventEmitter<any>();

	/** matMenu */
	@Input() matMenuTrigger: MatMenuTrigger;

	/**
	 * Default Constructor
	 */
	constructor(
	) {
		this.today.setHours(0, 0, 0, 0);
	}

	/**
	 * close
	 */
	close() {
		if (this.matMenuTrigger) {
			this.matMenuTrigger.closeMenu();
		}
	}
}

